import { createSlice } from '@reduxjs/toolkit';
import reducer from './reducer';

const initialState = {
  list: [],
  viewItem: undefined,
};

export default createSlice({
  name: 'selects',
  initialState: initialState,
  reducers: reducer,
});
